// eslint-disable-next-line jira/filename-case
import React, { useMemo } from 'react';
import ScreenSpaceFlags from '@post-office-placement/screen-space-flags/placement';
import killswitch from '@jira/platform__utils-feature-gates-killswitch/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useFlagsService } from '@atlassian/jira-flags';
import Placement from '@atlassian/post-office-placement/placement';
import { ScreenSpaceFlagPlacementPreviewSwitcher } from '@atlassian/post-office-placement/preview';
import { POST_OFFICE_KILL_SWITCH } from './constants.tsx';
import { isRestrictedFromPostOfficeSynthetic } from './is-restricted-from-post-office-synthetic.tsx';

const PLACEMENT_ID = 'screen-space-flags';

// NOTE: Do not clean up this FF. It has overrides configured that restrict several jira
// pollinator bot accounts from bombarding PO with requests and causing Stargate rate
// limit alerts. Until we have a permanent solution, this FF has been marked as a permanent
// feature gate in Statsig.
// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/post-office-screen-space-overlay-jfe
export const ScreenSpaceFlagsPlacement = (): React.JSX.Element | null => {
	const isRestrictedSynthetic = isRestrictedFromPostOfficeSynthetic();

	const flagsService = useFlagsService();

	const stablePlacementProps = useMemo(
		() => ({
			jiraFlagsService: {
				dismissFlag: flagsService.dismissFlag,
				hasFlag: flagsService.hasFlag,
				showFlag: flagsService.showFlag,
			},
		}),
		[flagsService?.dismissFlag, flagsService?.hasFlag, flagsService?.showFlag],
	);

	if (__SERVER__ || killswitch(POST_OFFICE_KILL_SWITCH) || isRestrictedSynthetic) {
		return null;
	}

	return fg('post-office-screen-space-overlay-jfe') ? (
		<ScreenSpaceFlagPlacementPreviewSwitcher
			// https://switcheroo.atlassian.com/ui/gates/8fe500fb-6c32-48c7-be3f-caf511e97a8e/key/post-office_enable_screen-space-preview_jfe
			isEnabled
		>
			<Placement
				placementId={PLACEMENT_ID}
				PlacementComponent={ScreenSpaceFlags}
				disableInitialData
				placementProps={stablePlacementProps}
			/>
		</ScreenSpaceFlagPlacementPreviewSwitcher>
	) : null;
};
